import { useState } from 'react';
import axios from 'axios';
import { useAtomValue } from 'jotai';
import MainURL from '../../../../MainURL';
import { loginStateAtom } from '../../../../AtomStore';

export interface ContiCondition {
  stateSort: string;
  theme: string;
  tempoSort: string;
}

export interface ContiAiResult {
  songCount: number | null;
  conditions: ContiCondition[];
}

export function useContiAi() {
  const isLogin = useAtomValue(loginStateAtom);

  const [aiText, setAiText] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const ensureLoggedIn = () => {
    if (!isLogin || !localStorage.getItem('refreshToken')) {
      alert('로그인이 필요합니다.');
      return false;
    }
    return true;
  };

  const handleGenerate = async (
    stateSortOptions: string[],
    tempoSortOptions: string[]
  ): Promise<ContiAiResult | null> => {
    if (!aiText.trim()) {
      setErrorMessage('원하는 콘티를 설명하는 문장을 입력해주세요.');
      return null;
    }

    if (!ensureLoggedIn()) return null;

    const verifyToken = localStorage.getItem('refreshToken');

    setIsGenerating(true);
    setErrorMessage('');

    try {
      const res = await axios.post(`${MainURL}/api/sermon/conti`, {
        text: aiText,
        stateSortOptions,
        tempoSortOptions,
        verifyToken,
      });
      return res.data as ContiAiResult;
    } catch (error) {
      console.error('콘티 AI 조건 생성 오류:', error);
      const message = axios.isAxiosError(error) && error.response?.data?.error
        ? error.response.data.error
        : 'AI 조건 생성 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
      setErrorMessage(message);
      return null;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    isLogin,
    aiText, setAiText,
    isGenerating, errorMessage,
    handleGenerate,
  };
}
